import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../../utils/apiUrls";
import api from "../../../utils/api";

const initialState = {
    getMasterItemsDetails: [],
    getActivityList: [],
    searchCategories: [],
    isLoading: false,
    error: null
};

export const getMasterItems = createAsyncThunk("get_master_items", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getMasterItems,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error.response.data.message;
    }
});

export const getActivity = createAsyncThunk("get_activity", async (queryParams) => {
    try {
        let url = API_ENDPOINTS.getActivity;
        if (queryParams) {
            url += queryParams;
        }
        let data = {
            method: METHOD_TYPE.get,
            url: url,
        };
        const response = await api(data);
        return response.data.data;
    } catch (error) {
        throw error.response.data.message;
    }
});

export const toggleMasterStatus = createAsyncThunk("toggle_master_status", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.put,
            url: (API_ENDPOINTS.toggleMasterStatus + queryParams),
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        console.log('error::::', error.response)
        throw error.response.message;
    }
});

export const createSubCategories = createAsyncThunk("create_activities", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.createSubCategories,
            data: requestData
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error.response.data.message;
    }
});

export const updateSubCategories = createAsyncThunk("update_activities", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.updateSubCategories,
            data: requestData
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error.response.data.message;
    }
});

export const deleteSubCategories = createAsyncThunk("delete_activities", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.deleteSubCategories,
            data: requestData
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error.response.data.message;
    }
});

export const updateCategoryStatus = createAsyncThunk("toggle-act_id-active-status", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.put,
            url: API_ENDPOINTS.updateCategoryStatus + queryParams,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error.response.data.message;
    }
});

export const getSearchCategories = createAsyncThunk("search_categories", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.getSearchCategories,
            data: requestData
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error.response.data.message;
    }
});

export const getUploadUrl = createAsyncThunk("getUploadUrl", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getUploadUrl + queryParams,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        console.log('error::::', error.response.data)
        throw error.response.data.detail;
    }
});

const CategoriesSlice = createSlice({
    name: "Categories",
    initialState,
    reducers: {
        setUserName: (state, action) => {
            state.userName = action.payload
        },
    },
    extraReducers: (builder) => {
        const handleLoading = (state, action) => {
            state.isLoading = action.meta.requestStatus === 'pending';
        };

        builder
            .addCase(getMasterItems.fulfilled, (state, action) => {
                state.getMasterItemsDetails = action.payload;
            })
            .addCase(getActivity.fulfilled, (state, action) => {
                state.getActivityList = action.payload;
            })
            .addCase(getSearchCategories.fulfilled, (state, action) => {
                state.searchCategories = action.payload;
            })
            .addMatcher(
                (action) =>
                    action.type === getMasterItems.pending.type ||
                    action.type === getMasterItems.fulfilled.type ||
                    action.type === getMasterItems.rejected.type ||
                    action.type === getActivity.pending.type ||
                    action.type === getActivity.fulfilled.type ||
                    action.type === getActivity.rejected.type ||
                    action.type === toggleMasterStatus.pending.type ||
                    action.type === toggleMasterStatus.fulfilled.type ||
                    action.type === toggleMasterStatus.rejected.type ||
                    action.type === createSubCategories.pending.type ||
                    action.type === createSubCategories.fulfilled.type ||
                    action.type === createSubCategories.rejected.type ||
                    action.type === updateSubCategories.pending.type ||
                    action.type === updateSubCategories.fulfilled.type ||
                    action.type === updateSubCategories.rejected.type ||
                    action.type === deleteSubCategories.pending.type ||
                    action.type === deleteSubCategories.fulfilled.type ||
                    action.type === deleteSubCategories.rejected.type ||
                    action.type === updateCategoryStatus.pending.type ||
                    action.type === updateCategoryStatus.fulfilled.type ||
                    action.type === updateCategoryStatus.rejected.type,
                handleLoading
            );
    }

});

export const { setUserName } = CategoriesSlice.actions;
export default CategoriesSlice.reducer;